import React from "react";
import { withNamespaces } from "react-i18next";
import {
    Modal,
    ModalBody,
    ModalHeader
} from "reactstrap";
import ClockIcon from "../../assets/icons/clockIcon.png";
import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_TIME_FORMAT } from "src/common/constants";

const PlatformUpdateModal = (props) => {
    const { selectedUpdate, setSelectedUpdate } = props;
    if (!selectedUpdate) return null;

    const dateUtils = new DateUtils();

    return (
        <Modal
            isOpen={!!selectedUpdate}
            toggle={() => setSelectedUpdate(undefined)}
            size="xl"
        >
            <ModalHeader toggle={() => setSelectedUpdate(undefined)}>
                <span dangerouslySetInnerHTML={{ __html: selectedUpdate.title }} />
            </ModalHeader>

            <ModalBody>
                {selectedUpdate.arcadeVideo ? (
                    <div
                        dangerouslySetInnerHTML={{ __html: selectedUpdate.arcadeVideo || "" }}
                    />
                ) : (
                    <>
                        {selectedUpdate.image && (
                            <img
                                src={selectedUpdate.image}
                                alt={selectedUpdate.title}
                                style={{ width: '100%', marginBottom: '1rem' }}
                            />
                        )}
                    </>
                )}
                
                <div
                    dangerouslySetInnerHTML={{ __html: selectedUpdate.body }}
                    style={{ marginBottom: '1rem' }}
                />
                <div className="text-muted small">
                    <span className="pe-2">
                        <img src={ClockIcon} alt="icon" width={24} height={24} />
                    </span>
                    <span>
                        {dateUtils.convertDateToDate(selectedUpdate.createdAt, INTERNATIONAL_DATE_TIME_FORMAT)}
                    </span>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default withNamespaces()(PlatformUpdateModal);
